import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BaseForm } from 'src/app/view/base-form';
import { TratamientosApiService } from 'src/app/service/api/tratamientos-api.service';
import { build, clearDropdownSelected, getDropdownSelectedSingle, list, stack } from '@fitogest/reactive-form-builder/utils';
import moment from 'moment';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';
import { CamposApiService } from 'src/app/service/api/campos-api.service';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { UsuariosApiService } from '../../../../../service/api/usuarios-api.service';
import { firstValueFrom } from 'rxjs';

import { BoquillaModel } from 'src/app/models/trabajadores/boquillas.model';
import { TratamientoManezModel } from 'src/app/models/tratamientos/tratatamiento-manez.model';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { BaseResponseModel } from 'src/app/models/base-response.model';
import {
    DropdownData,
    ReactiveFormLifecycleEvent,
    ReactiveFormStableValueChange,
    FormType,
} from '@fitogest/reactive-form-builder/interfaces';
import { type Campos, modoTrabajo, regulacionDosis, TrataManezReactiveFormDefinition } from './form-control/form-definition';

@Component({
    selector: 'app-trata-manez-form',
    standalone: false,
    templateUrl: './trata-manez-form.component.html',
    styleUrls: ['./trata-manez-form.component.scss']
})
export class TrataManezFormComponent extends BaseForm<TratamientoManezModel> implements OnInit {

    public rol = (StorageManager.getUser()).rol;

    public unidad = (StorageManager.getUser()).uds_medida || 'Hectárea';
    public ratio = StorageManager.getUser().ratio_ha || 1;
    public userId = (StorageManager.getUser()).id;
    public totalCaudales: number[] = [];
    public readonly pressureValues = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
    public boquilla: BoquillaModel= {
        hci: {index: []},
        amt: {index: []},
    };
    public tablaCaudales: BoquillaModel = {
        hci: {
            index: ['h005', 'h0075', 'h01', 'h015', 'h02', 'h025', 'h03', 'h035', 'h04', 'h05'],
            3: [0.19, 0.3, 0.4, 0.6, 0.8, 1, 1, 2, 1.4, 1.6, 2],
            4: [0.22, 0.35, 0.46, 0.69, 0.92, 1.15, 1.39, 1.62, 1.85, 2.31],
            5: [0.25, 0.39, 0.52, 0.77, 1.03, 1.29, 1.55, 1.81, 2.07, 2.58],
            6: [0.27, 0.42, 0.57, 0.85, 1.13, 1.41, 1.7, 1.98, 2.26, 2.83],
            7: [0.29, 0.46, 0.61, 0.92, 1.22, 1.53, 1.83, 2.14, 2.44, 3.06],
            8: [0.31, 0.49, 0.65, 0.98, 1.31, 1.63, 1.96, 2.29, 2.61, 3.27],
            9: [0.33, 0.52, 0.69, 1.04, 1.39, 1.73, 2.08, 2.42, 2.77, 3.46],
            10: [0.35, 0.55, 0.73, 0.1, 1.46, 1.83, 2.19, 2.56, 2.92, 3.65],
            11: [0.36, 0.57, 0.77, 1.15, 1.53, 1.91, 2.3, 2.68, 3.06, 3.83],
            12: [0.38, 0.6, 0.8, 1.2, 1.6, 2, 2.4, 2.8, 3.2, 4],
            13: [0.4, 0.62, 0.83, 1.25, 1.67, 2.08, 2.5, 2.91, 3.33, 4.16],
            14: [0.41, 0.65, 0.86, 1.31, 1.73, 2.16, 2.59, 3.02, 3.46, 4.32],
            15: [0.42, 0.67, 0.89, 1.34, 1.79, 2.24, 2.68, 3.13, 3.58, 4.47],
            16: [0.44, 0.69, 0.92, 1.39, 1.85, 2.31, 2.77, 3.23, 3.7, 4.62],
            17: [0.45, 0.71, 0.95, 1.43, 1.9, 2.38, 2.86, 3.33, 3.81, 4.76],
            18: [0.47, 0.73, 0.98, 1.47, 1.96, 2.45, 2.94, 3.43, 3.92, 4.9],
            19: [0.48, 0.75, 1.01, 1.51, 2.01, 2.52, 3.02, 3.52, 4.03, 5.03],
            20: [0.49, 0.77, 1.03, 1.55, 1.55, 2.58, 3.1, 3.61, 4.13, 5.16]
        },
        // Valores referenciales. Se calculan en la función calcularTablaCaudal().
        amt: {
            index: ['a08', 'a1', 'a11', 'a12', 'a1212', 'a15', 'a1515', 'a18', 'a1818', 'a2', 'a22'],
            3: [0.45, 0.50, 0.88, 0.56, 1.16, 0.77, 1.93, 1.24, 2.33, 1.05, 2.30],
            4: [0.52, 0.58, 0.95, 0.67, 1.28, 0.89, 2.15, 1.40, 2.66, 1.22, 2.71],
            5: [0.60, 0.65, 1.02, 0.78, 1.40, 1.02, 2.37, 1.56, 3, 1.40, 3.12],
            6: [0.68, 0.72, 1.09, 0.89, 1.52, 1.15, 2.59, 1.72, 3.34, 1.58, 3.53],
            7: [0.75, 0.80, 1.16, 1, 1.64, 1.27, 2.81, 1.88, 3.67, 1.75, 3.94],
            8: [0.83, 0.87, 1.24, 1.10, 1.76, 1.40, 3.04, 2.04, 4.01, 1.93, 4.34],
            9: [0.90, 0.95, 1.31, 1.21, 1.88, 1.52, 3.26, 2.20, 4.34, 2.10, 4.75],
            10: [0.98, 1.02, 1.38, 1.32, 2, 1.65, 3.48, 2.36, 4.68, 2.28, 5.16],
            11: [1, 1.05, 1.45, 1.36, 2.10, 1.70, 3.65, 2.50, 4.92, 2.41, 5.36],
            12: [1.02, 1.08, 1.52, 1.40, 2.19, 1.76, 3.82, 2.63, 5.16, 2.54, 5.57],
            13: [1.04, 1.12, 1.58, 1.45, 2.29, 1.81, 3.98, 2.77, 5.40, 2.68, 5.77],
            14: [1.06, 1.15, 1.65, 1.49, 2.38, 1.87, 4.15, 2.90, 5.64, 2.81, 5.98],
            15: [1.08, 1.18, 1.72, 1.53, 2.48, 1.92, 4.32, 3.04, 5.88, 2.94, 6.18],
            16: [1.12, 1.22, 1.77, 1.60, 2.56, 2.02, 4.49, 3.10, 6.10, 3.04, 6.42],
            17: [1.15, 1.27, 1.82, 1.66, 2.64, 2.11, 4.66, 3.17, 6.31, 3.13, 6.66],
            18: [1.19, 1.31, 1.86, 1.73, 2.72, 2.21, 4.82, 3.23, 6.53, 3.23, 6.90],
            19: [1.22, 1.36, 1.91, 1.79, 2.80, 2.30, 4.99, 3.30, 6.74, 3.32, 7.14],
            20: [1.26, 1.40, 1.96, 1.86, 2.88, 2.40, 5.16, 3.36, 6.96, 3.42, 7.38]
        }
    };

    public override model: TratamientoManezModel = {fecha: ''};
    public form!: TrataManezReactiveFormDefinition;
    public reactiveFormRecordId = '';
    public initialPreviousData: TratamientoManezModel | null = null;

    public productosAll: DropdownData<ProductosModel> = list<ProductosModel>(['...', null]);
    public campos: DropdownData<Campos> = list<Campos>(['...', null]);
    public maquinarias: DropdownData<MaquinariaModel> = list<MaquinariaModel>(['...', null]);
    public boquillas: DropdownData<BoquillaModel> = list<BoquillaModel>(['...', null]);
    public modo_trabajo: DropdownData<string> = modoTrabajo;
    public regulacion_dosis: DropdownData<string> = regulacionDosis;

    private hasRequestedTreatmentNumber = false;

    constructor(
        public override dashboard: DashboardService,
        public override router: Router,
        public override route: ActivatedRoute,
        public camposApi: CamposApiService,
        public trabajadoresApi: TrabajadoresApiService,
        public tratamientosApi: TratamientosApiService,
        public productosApi: ProductosApiService,
        public usuariosApi: UsuariosApiService,
        public http: HttpClient) {
        super(
            route,
            router,
            dashboard,
            tratamientosApi.tratamientosManez.PUT,
            tratamientosApi.tratamientosManez.POST,
            'tratamientos-manez',
            'Actualizar Tratamiento',
            'Crear Tratamiento',
            'Duplicar Tratamiento'
        );
    }

    ngOnInit(): void {
        moment.locale('es');

        this.model = this.initializeHostModel({ ...this.getModel() });
        this.reactiveFormRecordId = this.resolveReactiveFormRecordId(this.model);

        if (this.getType() === FormType.CREATION) {
            this.model.estado_tratamiento = 'Preparado';
        }

        this.form = new TrataManezReactiveFormDefinition(
            this.getType(),
            this.model,
            {
                campos: this.campos,
                maquinarias: this.maquinarias,
                boquillas: this.boquillas,
                productos: this.productosAll,
                modoTrabajo: this.modo_trabajo,
                regulacionDosis: this.regulacion_dosis
            },
            {
                getSelectedMaquinariaId: () => this.getSelectedMaquinariaId(),
                getCurrentUserId: () => this.userId,
                getSelectedProductIds: () => this.getSelectedProductIds()
            },
            this.unidad,
            this.userId,
            this.rol
        );

        this.initialPreviousData = { ...this.model };

        void this.initFormData();
        this.softInit(this.getType());
    }

    public stableValueChanges(event: ReactiveFormStableValueChange<TratamientoManezModel>): void {
        const tag = String(event.changedField);

        this.model = this.updateHostModel({ ...this.model, ...(event.value as TratamientoManezModel) });
        this.form.model = this.model;
        this.applyUnitFromModel();

        if (tag === '__previous_data_patch') {
            this.applyLoadedTreatmentState();
            return;
        }

        if (tag === '__dropdown_refresh') {
            this.formatProductos();
            this.formatBoquillas();
            this.setDefaultTreatmentNumber();
            return;
        }

        if (['marcha', 'litros', 'id_campo', 'ancho_calle'].includes(tag)) {
            this.calcularCaudal();
        }

        if (['id_maquinaria', 'id_boquilla'].includes(tag)) {
            if (tag === 'id_maquinaria') {
                this.model.id_boquilla = '';
                clearDropdownSelected(this.boquillas);
                this.formBuilderRef?.updateForm({ id_boquilla: null }, false);
            }
            this.formatBoquillas();
        }

        if (tag === 'id_campo') {
            this.getAnchoCalle();
        }
    }
    public onReactiveFormLifecycleEvent(event: ReactiveFormLifecycleEvent<TratamientoManezModel>): void {
        if (event.type !== 'previousDataPatched' && event.type !== 'previousDataChanged') {
            return;
        }

        this.model = this.updateHostModel({ ...this.model, ...(event.value as TratamientoManezModel) });
        this.form.model = this.model;
        this.applyLoadedTreatmentState();
    }


    public formatProductos(): void {
        const sourceOptions = this.productosAll.values.length > 0
            ? this.productosAll.values
            : this.productosAll.filtered;
        const selectedProductIds = this.getSelectedProductIds();

        const filteredOptions = sourceOptions.filter((it) => {
            const value = (it.raw ?? it.value) as ProductosModel | null;

            if (value === null) {
                return true;
            }

            return this.rol === 'admin'
                || value.id_usuario === this.userId
                || this.getComparableProductIds(value).some((id) => selectedProductIds.has(id));
        });

        this.productosAll.values = sourceOptions;
        this.productosAll.filtered = filteredOptions;
    }

    public formatBoquillas(): void {
        const selectedBoquilla = this.resolveSelectedBoquilla();

        if (selectedBoquilla) {
            this.boquilla = selectedBoquilla;

            const hci = this.boquilla.hci as unknown;
            const amt = this.boquilla.amt as unknown;

            if (typeof hci === 'string') {
                this.boquilla.hci = JSON.parse(hci);
            }
            if (typeof amt === 'string') {
                this.boquilla.amt = JSON.parse(amt);
            }
            this.calcularTablaCaudal();
            for (const i of this.pressureValues) {
                this.getCaudal(i);
            }
        } else {
            for (const i of this.pressureValues) {
                this.totalCaudales[i] = 0;
            }
        }
    }

    public calcularCaudal(): void {
        const proporcion = this.ratio;
        const velocidad = this.toNumber(this.model.marcha);
        const dosis = this.toNumber(this.model.litros) * proporcion;
        const anchoCalle = this.toNumber(this.model.ancho_calle);

        this.model.caudal = +((anchoCalle * velocidad * dosis) / 600).toFixed(2);
        this.formBuilderRef?.updateForm({ caudal: this.model.caudal }, false);
    }

    public getCaudal(tableIndex: number): void {
        let total = 0;

        for (const prop in this.boquilla.hci) {
            const idx = this.tablaCaudales.hci.index.indexOf(prop);

            if (idx >= 0) {
                total += Number(this.tablaCaudales.hci[tableIndex]?.[idx] || 0)
                    * this.getBoquillaAmount(this.boquilla.hci, prop);
            }
        }

        for (const prop in this.boquilla.amt) {
            const idx = this.tablaCaudales.amt.index.indexOf(prop);

            if (idx >= 0) {
                total += Number(this.tablaCaudales.amt[tableIndex]?.[idx] || 0)
                    * this.getBoquillaAmount(this.boquilla.amt, prop);
            }
        }

        this.totalCaudales[tableIndex] = +total.toFixed(2);
    }

    private getBoquillaAmount(group: BoquillaModel['hci'] | BoquillaModel['amt'], key: string): number {
        const rawValue = group?.[key];
        const amount = Number(rawValue || 0);

        return Number.isFinite(amount) ? amount : 0;
    }

    public getAnchoCalle(): void {
        try {
            const idCampo = this.normalizeId(this.model['id_campo']);

            if (!idCampo) {
                this.model.ancho_calle = '';
                this.formBuilderRef?.updateForm({ ancho_calle: '', caudal: 0 }, false);
                return;
            }

            firstValueFrom(this.http.get<BaseResponseModel<Campos>>(
                environment.serverUrl + 'ws/index.php?p1=generic&p2=campos&p3=' + idCampo
            ))
                .then((campos: BaseResponseModel<Campos>) => {
                    this.model.ancho_calle = (campos.data as Campos[])[0]?.marco_ancho ?? '';
                    this.formBuilderRef?.updateForm({ ancho_calle: this.model.ancho_calle }, false);
                    this.calcularCaudal();
                    return;
                }).catch((e) => {
                    console.log('catch en getPosition: ' + e);
                });
        } catch (error) {
            console.log(error);
            this.model.ancho_calle = '';
        }
    }

    private initFormData(): Promise<boolean> {
        const builds = [
            build(this.camposApi.campos.GET, this.campos, 'nombre', true),
            build(this.trabajadoresApi.boquillas.GET, this.boquillas, 'nombre', true),
            build(this.trabajadoresApi.maquinariaGET, this.maquinarias, 'nombre', true),
            build(this.productosApi.productos.GET, this.productosAll, 'nombre', false)
        ];

        return stack(builds)
            .then(() => {
                this.finalizeExternalDropdowns();
                this.formatProductos();
                this.formatBoquillas();
                this.refreshReactiveDropdownMappings();
                this.formBuilderRef?.forceRehydrateRepeatable('productos_repeatable');
                this.setDefaultTreatmentNumber();
                return true;
            });
    }

    private refreshReactiveDropdownMappings(): void {
        this.formBuilderRef?.refreshExternalDropdownMappings();
    }

    private applyLoadedTreatmentState(): void {
        this.applyUnitFromModel();
        this.ensureLegacyProductIdsFromLoadedProducts();
        this.formatProductos();
        this.formatBoquillas();
        this.calcularCaudal();
        this.patchReadOnlyCalculatedFields();
        this.formBuilderRef?.forceRehydrateRepeatable('productos_repeatable');
        this.setDefaultTreatmentNumber();
    }

    private patchReadOnlyCalculatedFields(): void {
        const patch: Record<string, unknown> = {};

        if (this.model.n_tratamiento !== null && this.model.n_tratamiento !== undefined && this.model.n_tratamiento !== 0) {
            patch['n_tratamiento'] = this.model.n_tratamiento;
        }

        if (this.model.caudal !== null && this.model.caudal !== undefined && this.model.caudal !== 0) {
            patch['caudal'] = this.model.caudal;
        }

        if (Object.keys(patch).length > 0) {
            this.formBuilderRef?.updateForm(patch, false);
        }
    }

    private resolveSelectedBoquilla(): BoquillaModel | null {
        const selectedBoquilla = getDropdownSelectedSingle(this.boquillas);
        const selectedBoquillaId = this.normalizeId(this.model.id_boquilla || selectedBoquilla);
        const options = this.boquillas.values.length > 0 ? this.boquillas.values : this.boquillas.filtered;
        const found = options.find((item) => item.value?.id?.toString() === selectedBoquillaId);

        return found?.value ?? selectedBoquilla ?? null;
    }

    private getSelectedMaquinariaId(): string {
        return this.normalizeId(this.model['id_maquinaria'] || getDropdownSelectedSingle(this.maquinarias));
    }

    private getSelectedProductIds(): ReadonlySet<string> {
        const selectedIds = new Set<string>();
        const addIds = (value: unknown): void => {
            for (const id of this.getComparableIds(value)) {
                selectedIds.add(id);
            }
        };

        String(this.model.ids_productos ?? '')
            .split(';')
            .forEach((id) => addIds(id));

        if (Array.isArray(this.model.productos)) {
            this.model.productos.forEach((producto) => addIds(producto));
        }

        const repeatableRows = (this.model as Record<string, unknown>)['productos_repeatable'];

        if (Array.isArray(repeatableRows)) {
            repeatableRows.forEach((row) => {
                if (row !== null && typeof row === 'object') {
                    addIds((row as Record<string, unknown>)['producto']);
                }
            });
        }

        return selectedIds;
    }

    private ensureLegacyProductIdsFromLoadedProducts(): void {
        if (String(this.model.ids_productos ?? '').trim() !== '' || !Array.isArray(this.model.productos)) {
            return;
        }

        const ids = this.model.productos
            .map((producto) => this.normalizeId(producto))
            .filter((id) => id !== '');

        if (ids.length > 0) {
            this.model.ids_productos = ids.join(';');
        }
    }

    private getComparableProductIds(product: ProductosModel): string[] {
        return this.getComparableIds(product);
    }

    private getComparableIds(value: unknown): string[] {
        const ids = new Set<string>();
        const add = (candidate: unknown): void => {
            const id = this.normalizeId(candidate);

            if (id === '') {
                return;
            }

            ids.add(id);

            if (/^\d+$/.test(id)) {
                ids.add(String(Number(id)));
            }
        };

        add(value);

        if (value !== null && typeof value === 'object') {
            const record = value as Record<string, unknown>;

            add(record['id']);
            add(record['value']);
            add(record['raw']);
        }

        return Array.from(ids);
    }

    private normalizeId(value: unknown): string {
        if (value === null || value === undefined) {
            return '';
        }

        if (typeof value === 'object') {
            const record = value as Record<string, unknown>;
            const wrappedValue = record['value'];

            if (wrappedValue !== null && wrappedValue !== undefined && typeof wrappedValue === 'object') {
                return this.normalizeId(wrappedValue);
            }

            return String(record['id'] ?? '').trim();
        }

        return String(value).trim();
    }

    private toNumber(value: unknown): number {
        const parsedValue = Number(String(value ?? '').replace(',', '.'));

        return Number.isFinite(parsedValue) ? parsedValue : 0;
    }

    private applyUnitFromModel(): void {
        if (!this.model.uds_medida) {
            return;
        }

        this.unidad = this.model.uds_medida;
        this.ratio = this.model.ratio_ha ?? 0;
        this.form.updateUnidad(this.unidad);
    }

    private setDefaultTreatmentNumber(): void {
        if (this.hasRequestedTreatmentNumber || ![FormType.CREATION, FormType.DUPLICATION].includes(this.getType())) {
            return;
        }

        if (!this.formBuilderRef?.model) {
            setTimeout(() => this.setDefaultTreatmentNumber(), 100);
            return;
        }

        this.hasRequestedTreatmentNumber = true;
        const usuario = this.normalizeId(this.model.id_usuario) || this.userId;

        this.tratamientosApi.tratamientosManez.GET.toPromise({ id_usuario: usuario } as never).then((res) => {
            const nextTreatmentNumber = (res as TratamientoManezModel[]).length + 1;

            this.model.n_tratamiento = nextTreatmentNumber;
            this.formBuilderRef?.updateForm({ n_tratamiento: nextTreatmentNumber }, false);
            return;
        }).catch((e) => {
            console.log('catch en getPosition: ' + e);
        });
    }

    private calcularTablaCaudal() {
        let D10: number, D15: number, D20: number, D25: number;

        for (const i of this.pressureValues) {
            for (const j of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]) {
                D10 = (this.tablaCaudales.amt[5] as number[])[j] ?? 0;
                D15 = (this.tablaCaudales.amt[10] as number[])[j] ?? 0;
                D20 = (this.tablaCaudales.amt[15] as number[])[j] ?? 0;
                D25 = (this.tablaCaudales.amt[20] as number[])[j] ?? 0;

                if (i < 5) {
                    (this.tablaCaudales.amt[i] as number[])[j] = D10 - (((D15 - D10) / 5) * (5 - i));
                } else if (i < 10) {
                    (this.tablaCaudales.amt[i] as number[])[j] = D10 + (((D15 - D10) / 5) * (i - 5));
                } else if (i < 15) {
                    (this.tablaCaudales.amt[i] as number[])[j] = D15 + (((D20 - D15) / 5) * (i - 10));
                } else if (i < 20) {
                    (this.tablaCaudales.amt[i] as number[])[j] = D20 + (((D25 - D20) / 5) * (i - 15));
                }
            }
        }

    }
}
